import Hero from './components/hero'
import Questions from './components/questions'
import Answer from './components/answer'
import Explanation from './components/explanation'
import Footer from './components/footer'
import { useEffect } from 'react'
import Aos from 'aos'
import 'aos/dist/aos.css';

function App() {
    useEffect(() => {
        setTimeout(() => {
            Aos.init({ duration: 500, once: "false" })
        }, 1000);
    }, []);
    return (
        <div className="App">
            <Hero />
            <Questions />
            <Answer />
            <Explanation />
            <Footer />
        </div>
    );
}

export default App;
